<form [formGroup]="medicalHistoryForm" >
    <div class="step-container">
      <ng-template #labelEight>{{ getTranslation('medicalHistory.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('medicalHistory.title') : getTranslation('medicalHistory.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>

      <div *ngIf="isJsonShow">
        {{medicalHistoryForm.value | json}}

      </div>

      <div class="row gx-2">
        <!-- Height - Feet and Inches -->
        <div class="form-group col-12 col-md-6 mb-3">
          <!-- <label class="form-label">{{ getTranslation('medicalHistory.height') }}</label> -->
          <div class="row gx-2">
            <div class="col-6">
              <label for="HeightFeet" class="form-label small">{{ getTranslation('medicalHistory.feet') }}</label>
              <ng-select id="HeightFeet" formControlName="HeightFeet" [searchable]="true"
                [ngClass]="{'invalid-select': medicalHistoryForm.get('HeightFeet')?.invalid && medicalHistoryForm.get('HeightFeet')?.touched}">
                <ng-option value="" disabled selected hidden>{{ getTranslation('medicalHistory.select') }}</ng-option>
                <ng-option *ngFor="let feet of heightFeet" [value]="feet">
                  {{ feet }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && medicalHistoryForm.controls['HeightFeet'].invalid" class="text-danger">
                {{ getTranslation('validation.feetRequired') }}
              </div>
            </div>
            <div class="col-6">
              <label for="HeightInch" class="form-label small">{{ getTranslation('medicalHistory.inches') }}</label>
              <ng-select id="HeightInch" formControlName="HeightInch" [searchable]="true"
                [ngClass]="{'invalid-select': medicalHistoryForm.get('HeightInch')?.invalid && medicalHistoryForm.get('HeightInch')?.touched}">
                <ng-option value="" disabled selected hidden>{{ getTranslation('medicalHistory.select') }}</ng-option>
                <ng-option *ngFor="let inch of heightInch" [value]="inch">
                  {{ inch }}
                </ng-option>
              </ng-select>
              <div *ngIf="submitted && medicalHistoryForm.controls['HeightInch'].invalid" class="text-danger">
                {{ getTranslation('validation.inchesRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <!-- Weight -->
        <div class="form-group col-12 col-md-6 mb-3">
          <label for="Weight" class="form-label">{{ getTranslation('medicalHistory.weight') }}</label>
          <!-- <input type="text" class="form-control" id="Weight" formControlName="Weight" placeholder="Enter Weight"> -->
          

          <ng-select id="Weight" formControlName="Weight" [searchable]="true"
          [ngClass]="{'invalid-select': medicalHistoryForm.get('Weight')?.invalid && medicalHistoryForm.get('Weight')?.touched}" 
          >
            <ng-option value="" disabled selected hidden>{{ getTranslation('medicalHistory.select') }}</ng-option>
            <ng-option *ngFor="let weight of weights" [value]="weight">
              {{ weight }}
            </ng-option>
          </ng-select>


          <!-- <select class="form-control" id="Weight" formControlName="Weight" required>
            <option value="" disabled selected>Select Weight</option>
            <option *ngFor="let weight of weights" [value]="weight">{{ weight }} </option>
          </select> -->


          <div *ngIf="submitted && medicalHistoryForm.controls['Weight'].invalid" class="text-danger">
            {{ getTranslation('validation.weightRequired') }}
          </div>
        </div>
  
        <!-- 1. Blood Pressure -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsBloodPressureProblem'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.bloodPressure') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsBloodPressureProblem" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsBloodPressureProblem" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsBloodPressureProblem'].invalid" class="text-danger-val">
                {{ getTranslation('validation.bloodPressureRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsBloodPressureProblem')?.value === true">
          <label for="BpRange" class="form-label">{{ getTranslation('medicalHistory.provideCurrentReading') }}</label>
          <input type="text" class="form-control" id="BpRange" formControlName="BpRange" [placeholder]="getTranslation('medicalHistory.enterBpRange')" maxlength="50">
          <div *ngIf="submitted && medicalHistoryForm.controls['BpRange'].invalid" class="text-danger">
            {{ getTranslation('validation.bpRangeRequired') }}
          </div>
        </div>

        <!-- 2. Blood Sugar or Diabetes -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsBloodSugarProblem'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.bloodSugarDiabetes') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsBloodSugarProblem" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsBloodSugarProblem" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsBloodSugarProblem'].invalid" class="text-danger-val">
                {{ getTranslation('validation.bloodSugarRequired') }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsBloodSugarProblem')?.value === true">
          <label for="BloodSugarRange" class="form-label">{{ getTranslation('medicalHistory.provideCurrentReading') }}</label>
          <input type="text" class="form-control" id="BloodSugarRange" formControlName="BloodSugarRange" [placeholder]="getTranslation('medicalHistory.enterBloodSugarRange')" maxlength="50">
          <div *ngIf="submitted && medicalHistoryForm.controls['BloodSugarRange'].invalid" class="text-danger">
            {{ getTranslation('validation.bloodSugarRangeRequired') }}
          </div>
        </div>

        <!-- 3. Brain Stroke -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsBrainStroke'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.brainStroke') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio"  formControlName="IsBrainStroke" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio"  formControlName="IsBrainStroke" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsBrainStroke']?.invalid" class="text-danger-val">
                {{ getTranslation('validation.brainStrokeRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsBrainStroke')?.value === true">
          <label for="BrainStrokeDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="BrainStrokeDetails" formControlName="BrainStrokeDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['BrainStrokeDetails']?.invalid" class="text-danger">
            {{ getTranslation('validation.brainStrokeDetailsRequired') }}
          </div>
        </div>

        <!-- 4. Heart Disease -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsHeartProblem'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.heartDisease') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsHeartProblem" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsHeartProblem" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsHeartProblem'].invalid" class="text-danger-val">
                {{ getTranslation('validation.heartProblemRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsHeartProblem')?.value === true">
          <label for="HeartProblemDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="HeartProblemDetails" formControlName="HeartProblemDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['HeartProblemDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.heartProblemDetailsRequired') }}
          </div>
        </div>

        <!-- 5. Tuberculosis (TB) -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsTuberculosis'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.tuberculosis') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsTuberculosis" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsTuberculosis" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsTuberculosis'].invalid" class="text-danger-val">
                {{ getTranslation('validation.tuberculosisRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsTuberculosis')?.value === true">
          <label for="TuberculosisDetails" class="form-label">{{ getTranslation('medicalHistory.whenTreatmentComplete') }}</label>
          <input type="text" class="form-control" id="TuberculosisDetails" formControlName="TuberculosisDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['TuberculosisDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.tuberculosisDetailsRequired') }}
          </div>
        </div>

        <!-- 6. Asthma -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsAsthma'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.asthma') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsAsthma" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsAsthma" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsAsthma'].invalid" class="text-danger-val">
                {{ getTranslation('validation.asthmaRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsAsthma')?.value === true">
          <label for="AsthmaDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="AsthmaDetails" formControlName="AsthmaDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['AsthmaDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.asthmaDetailsRequired') }}
          </div>
        </div>

        <!-- 7. Cancer -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsCancer'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.cancer') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsCancer" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsCancer" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsCancer'].invalid" class="text-danger-val">
                {{ getTranslation('validation.cancerRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsCancer')?.value === true">
          <label for="CancerDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="CancerDetails" formControlName="CancerDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['CancerDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.cancerDetailsRequired') }}
          </div>
        </div>

        <!-- 8. HIV / Aids -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsHiv'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.hivAids') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsHiv" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsHiv" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsHiv'].invalid" class="text-danger-val">
                {{ getTranslation('validation.hivRequired') }}
              </div>
            </div>
          </div>
          
        </div>


          <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsHiv')?.value === true">
            <label for="HivConditionDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
            <input type="text" class="form-control" id="HivConditionDetails" formControlName="HivConditionDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
            <div *ngIf="submitted && medicalHistoryForm.controls['HivConditionDetails'].invalid" class="text-danger">
              {{ getTranslation('validation.hivConditionDetailsRequired') }}
            </div>
          </div>





        <!-- 9. Respiratory / Lung problem -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsLungProblem'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.respiratoryLungProblem') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsLungProblem" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsLungProblem" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsLungProblem'].invalid" class="text-danger-val">
                {{ getTranslation('validation.lungProblemRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsLungProblem')?.value === true">
          <label for="LungProblemDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="LungProblemDetails" formControlName="LungProblemDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['LungProblemDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.lungProblemDetailsRequired') }}
          </div>
        </div>

        <!-- 10. Problem related to Vision, Hearing or Speech -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsVisionProblem'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.visionHearingSpeechProblem') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsVisionProblem" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsVisionProblem" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsVisionProblem'].invalid" class="text-danger-val">
                {{ getTranslation('validation.visionProblemRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsVisionProblem')?.value === true">
          <label for="VisionProblemDetails" class="form-label">{{ getTranslation('medicalHistory.describeCurrentCondition') }}</label>
          <input type="text" class="form-control" id="VisionProblemDetails" formControlName="VisionProblemDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['VisionProblemDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.visionProblemDetailsRequired') }}
          </div>
        </div>

        <!-- 11. Depression or other psychological condition -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsDepression'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.depressionPsychological') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsDepression" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsDepression" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsDepression'].invalid" class="text-danger-val">
                {{ getTranslation('validation.depressionRequired') }}
              </div>
            
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsDepression')?.value === true">
          <label for="DepressionDetails" class="form-label">{{ getTranslation('medicalHistory.specify') }}</label>
          <input type="text" class="form-control" id="DepressionDetails" formControlName="DepressionDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
      
          <div *ngIf="submitted && medicalHistoryForm.controls['DepressionDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.depressionDetailsRequired') }}
          </div>
        </div>

        <!-- 12. Other medical condition -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsOtherMedicalCondition'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.otherMedicalCondition') }}  <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsOtherMedicalCondition" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsOtherMedicalCondition" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsOtherMedicalCondition'].invalid" class="text-danger-val">
                {{ getTranslation('validation.otherMedicalConditionRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsOtherMedicalCondition')?.value === true">
          <label for="OtherMedicalConditionDetails" class="form-label">{{ getTranslation('medicalHistory.pleaseDescribe') }}</label>
          <input type="text" class="form-control" id="OtherMedicalConditionDetails" formControlName="OtherMedicalConditionDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['OtherMedicalConditionDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.otherMedicalConditionDetailsRequired') }}
          </div>
        </div>

        <!-- Additional fields that were in the original form -->
        <!-- Typhoid Fever -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': medicalHistoryForm.controls['IsTyphoidFever'].invalid && submitted}">{{ getTranslation('medicalHistory.typhoidFever') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsTyphoidFever" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsTyphoidFever" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
           
              <div *ngIf="submitted && medicalHistoryForm.controls['IsTyphoidFever'].invalid" class="text-danger-val">
                {{ getTranslation('validation.typhoidFeverRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsTyphoidFever')?.value === true">
          <label for="TyphoidFeverDetails" class="form-label">{{ getTranslation('medicalHistory.ifYesWhen') }}</label>
          <input type="text" class="form-control" id="TyphoidFeverDetails" formControlName="TyphoidFeverDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="50">
        
          <div *ngIf="submitted && medicalHistoryForm.controls['TyphoidFeverDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.typhoidFeverDetailsRequired') }}
          </div>

        </div>

        <!-- Psychiatric disorder -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsPsychiatricDisorder'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.psychiatricDisorder') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" class="form-check-input" formControlName="IsPsychiatricDisorder" [value]="true" class="me-2"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" class="form-check-input" formControlName="IsPsychiatricDisorder" [value]="false" class="me-2"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsPsychiatricDisorder'].invalid" class="text-danger-val">
                {{ getTranslation('validation.psychiatricDisorderRequired') }}
              </div>
            </div>
          </div>
        </div>
  
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsPsychiatricDisorder')?.value === true">
          <label for="PsychiatricDisorderDetails" class="form-label">{{ getTranslation('medicalHistory.ifYesWhenWhatKind') }}</label>
          <input type="text" class="form-control" id="PsychiatricDisorderDetails" formControlName="PsychiatricDisorderDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['PsychiatricDisorderDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.psychiatricDisorderDetailsRequired') }}
          </div>
        </div>

        <!-- IsParasites -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsParasites'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.parasites') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsParasites" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsParasites" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsParasites'].invalid" class="text-danger-val">
                {{ getTranslation('validation.parasitesRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsParasites')?.value === true">
          <label for="ParasitesDetails" class="form-label">{{ getTranslation('medicalHistory.ifYesWhenWhatKind') }}</label>
          <input type="text" class="form-control" id="ParasitesDetails" formControlName="ParasitesDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['ParasitesDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.parasitesDetailsRequired') }}
          </div>
        </div>
        
        <!-- IsHepatitis A, B, or C or yellow jaundice -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsHepatitis'].invalid && submitted}"
            >{{ getTranslation('medicalHistory.hepatitis') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5"><input type="radio" formControlName="IsHepatitis" [value]="true"> {{ getTranslation('common.yes') }}</label>
              <label><input type="radio" formControlName="IsHepatitis" [value]="false"> {{ getTranslation('common.no') }}</label>
              <div *ngIf="submitted && medicalHistoryForm.controls['IsHepatitis'].invalid" class="text-danger-val">
                {{ getTranslation('validation.hepatitisRequired') }}
              </div> 
            </div>
          </div>
        </div>
        
        <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsHepatitis')?.value === true">
          <label for="HepatitisDetails" class="form-label">{{ getTranslation('medicalHistory.ifYesWhenWhichOne') }}</label>
          <input type="text" class="form-control" id="HepatitisDetails" formControlName="HepatitisDetails" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
          <div *ngIf="submitted && medicalHistoryForm.controls['HepatitisDetails'].invalid" class="text-danger">
            {{ getTranslation('validation.hepatitisDetailsRequired') }}
          </div>
        </div>













           <!-- Regular Medication -->
           <div class="form-group col-12 mb-3">
            <div class="row">
              <label class="form-label col-md-5 mb-0"  [ngClass]="{'text-danger': medicalHistoryForm.controls['IsRegularMedication'].invalid && submitted}"
              >{{ getTranslation('medicalHistory.regularMedication') }} <span class="text-danger">*</span></label>
              <div class="col-md-4 d-flex align-items-center">
                <label class="mr-5"><input type="radio" formControlName="IsRegularMedication" [value]="true"> {{ getTranslation('common.yes') }}</label>
                <label><input type="radio" formControlName="IsRegularMedication" [value]="false"> {{ getTranslation('common.no') }}</label>
                <div *ngIf="submitted && medicalHistoryForm.controls['IsRegularMedication'].invalid" class="text-danger-val">
                  {{ getTranslation('validation.regularMedicationRequired') }}
                </div> 
              </div>
            </div>
          </div>
          
          <div class="form-group col-12 mb-3" *ngIf="medicalHistoryForm.get('IsRegularMedication')?.value === true">
            <label for="Medications" class="form-label">{{ getTranslation('medicalHistory.pleaseSpecifyMedicine') }}</label>
            <input type="text" class="form-control" id="Medications" formControlName="Medications" [placeholder]="getTranslation('medicalHistory.enterDetails')" maxlength="100">
            <div *ngIf="submitted && medicalHistoryForm.controls['Medications'].invalid" class="text-danger">
              {{ getTranslation('validation.medicationsRequired') }}
            </div>
          </div>













        <!-- Medications -->
        <!-- <div  class="form-group col-12 mb-3">
          <label for="Medications"  class="form-label">Medications: Write all the regular medicines you take. (If none, write 'none'):</label>
          <textarea id="Medications" formControlName="Medications" rows="3" class="form-control"></textarea>
          <div *ngIf="submitted && medicalHistoryForm.controls['Medications'].invalid" class="text-danger">
            This field is required.
          </div>
        </div> -->
        
      </div>
    </div>
     <!-- Buttons start -->
     <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable" >
      <button type="button" class="btn savedraftbtn" 
              *ngIf="medicalHistoryForm.get('SaveMode')?.value !== SaveMode.SAVE"
              (click)="onSubmit(SaveMode.DRAFT)">
        <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
      </button>
      <button type="button" class="btn prevbtn" (click)="goToBack()">
        <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
      </button>
      <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
        <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
      </button>
    </div>
     <!-- Buttons ends -->
      </form>
  